<template>
  <div class="release-notes-page">
    <h1 class="bold-font release-notes-title">
      {{ t("release_notes.title") }}
    </h1>
    <div class="release-notes-content" v-html="releaseNotesContent"></div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "../store/index.js";
import authService from "../services/auth.service.js";

export default {
  name: "ReleaseNotes",
  setup() {
    const { t } = useI18n();

    const releaseNotesContent = ref("");

    // release notes are shown only in the Vind environments (not in portals / SKS)
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    onMounted(async () => {
      if (!isVind.value) return;
      try {
        const res = await authService.getReleaseNotesContent();
        releaseNotesContent.value = res?.releaseNotesContent ?? "";
      } catch {
        releaseNotesContent.value = "";
      }
    });

    return {
      t,
      releaseNotesContent,
    };
  },
};
</script>
